var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" ©2013－2020 DataCastle蜀ICP备17028166号-1 ")])}
var staticRenderFns = []

export { render, staticRenderFns }